<template>
	<div class="h-100 d-flex flex-column align-center justify-center">
    <h2>Votre compte à été banni.</h2>
    <p>Pour en savoir plus, veuillez contacter un administrateur.</p>
  </div>
</template>
